
import React, { useState, useEffect, useCallback } from 'react';
import axios from "axios";
import Download from 'assets/image/Download.svg';
import Account from 'assets/image/Account.svg';
import callGetApi from "../../../../requests/GetRequests";
import * as Constants from '../../../../requests/URLConstants';
import callPostApi from "../../../../requests/PostRequests";
import { Search, Button } from 'carbon-components-react';
import i18n from "../../../../i18n";
import { ArrowUpRight20 } from "@carbon/icons-react";
import ReadMoreAndLess from 'react-read-more-less';
import InlineLoading from 'carbon-components-react/lib/components/InlineLoading';
import * as DashboardConstants from '../../../Dashboards/DashboardConstants'
var config = require('../../../../config/appConfig.json');
require("./_assistace-tab.scss");

const AssistanceTab = props => {

    const [qsgDocumentName, setQsgDocumentName] = useState([]);
    const [qsgDownloadLink, setQsgDownloadLink] = useState([]);
    const [sampleJsonArray, setSampleJsonArray] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [QnALoader, setQnALoader] = useState(false);
    const [KnowlegdeArticleLoader, setKnowlegdeArticleLoader] = useState(false);

    const getMoreAssistance = i18n.t('assistance.GetMoreAssistance');
    const QA = i18n.t('assistance.QA');
    const knowledgeArticles = i18n.t('assistance.knowledgeArticles');
    const NoDataWasFound = i18n.t('assistance.NoDataWasFound');
    const ReadMore = i18n.t('assistance.ReadMore');
    const ReadLess = i18n.t('assistance.ReadLess');

    useEffect(() => {

        let sampleQA = {
            "questions": [
                "What command needs to be executed to access log message?",
                "What should be doen If the process is running more than 2500 in not enough dialog resource?"
            ],
            "answers": [
                "SM21",
                "If the runtime is more than 2500, we need to call and inform BASIS team regarding the same. Once we inform the BASIS team, they let us know whether the work process is critical or not at that time. If it is not critical, the BASIS team might act upon it immediately but if it is critical we are asked to monitor it for a dynamic time. We monitor the work process till that time and the issue is closed once either the user doesn�t the hold the work process or the BASIS team acts upon it"
            ]
        };
        if (props) {
            questionAnswers(props.process);
        }
        setKnowlegdeArticleLoader(true);
        callGetApi(Constants.KNOWLEDGEARTICLESURL + props.sysId, { 'Content-Type': 'application/json' })
            .then(response => {
                return response;
            }).then(resp => {
                if (resp) {
                    setKnowlegdeArticleLoader(false);
                    if (resp[0].u_qsg_document_name) {
                        var qsgdocumentnamearray = resp[0].u_qsg_document_name.replace('[', '').replace(']', '').split(',');
                        setQsgDocumentName(oldArray => [...oldArray, qsgdocumentnamearray]);
                        var qsgdocumentlinkarray = resp[0].u_qsg_document_download_link.replace('[', '').replace(']', '').split(',');
                        setQsgDownloadLink(oldArray => [...oldArray, qsgdocumentlinkarray]);


                        let newstate = Object.assign([], sampleJsonArray);
                        for (var j = 0; j < qsgdocumentnamearray.length; j++) {
                            for (var k = 0; k < qsgdocumentlinkarray.length; k++) {
                                if (j === k) {
                                    newstate = [...newstate, { displayname: qsgdocumentnamearray[j], link: qsgdocumentlinkarray[k] }];
                                    setSampleJsonArray(newstate);
                                }
                            }
                        }
                    }
                }
            }).catch((error) => {
                console.error('Error:', error);
                setKnowlegdeArticleLoader(false);
            });


    }, [props]);

    const downloadDocument = useCallback((e, documentlink) => {

        callPostApi(Constants.DOWNLOADKNOWLEDGEARTICLEURL, {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }, {
            "doc_url": documentlink
        })
            .then(data => {
                window.open(data);

            });
    });

    const questionAnswers = (process) => {
        setQnALoader(true);
        callPostApi(Constants.QUESTIONANSWERSURL, {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }, {
            "process": process
        })
            .then(data => {
                if (data) {
                    setQnALoader(false);
                    setQuestions(data.questions);
                    setAnswers(data.answers);
                }
            }).catch((error) => {
                setQnALoader(false);
            });
    }

    const callAgentAssist = () => {
        window.open("https://cognitiveassistant.in.edst.ibm.com/");
    }

    return (

        <div className="assistance-container carbon-display-Regular-14">

            <div className="assistance-sub-container">
                <div className="documents">
                    <div className="margin-bottom-heading carbon-display-Regular-20">{knowledgeArticles}</div>
                    <div>
                        <div className="white-background">
                            {KnowlegdeArticleLoader === false ?
                                sampleJsonArray.length > 0 ? sampleJsonArray.map(entry =>
                                    <div className="doc-data">
                                        <div>
                                            <img className="image-size margin-right" src={Account} alt="" />
                                            <span className="text-color carbon-display-Regular-14">{entry.displayname}</span>
                                            <div className="download-icon">
                                                <img className="image-size" src={Download} onClick={(e) => downloadDocument(e, entry.link)} alt="" />
                                            </div>
                                        </div>
                                        <div className="line"></div>
                                    </div>)
                                    : <div>{NoDataWasFound}</div>
                                : <InlineLoading description={DashboardConstants.Loading} />}
                        </div>
                    </div>
                    <div className="margin-top">
                    </div>
                </div>
                <div className="question-answers">
                    <div className="margin-bottom-heading carbon-display-Regular-20"> {QA}</div>
                    <div className="white-background">
                        {QnALoader === false ?
                            answers && answers.length > 0 && questions && questions.length > 0 ? questions.map((entry, index) =>
                                <div className="doc-data">
                                    <div className="questions carbon-display-Regular-14">{entry}</div>
                                    {/* <div className="answers carbon-display-Regular-14">{answers[index]}</div> */}
                                    <div className="answers carbon-display-Regular-14">
                                        <ReadMoreAndLess
                                            // ref={this.ReadMore}
                                            className="read-more-content"
                                            charLimit={250}
                                            readMoreText={ReadMore}
                                            readLessText={ReadLess}
                                        >
                                            {answers[index]}
                                        </ReadMoreAndLess>
                                    </div>
                                    <div className="line-questions"></div>
                                </div>)
                                : <div>{NoDataWasFound}</div>
                            : <InlineLoading description={DashboardConstants.Loading} />}
                        <Button className="assistance-button" renderIcon={ArrowUpRight20} kind='tertiary' onClick={callAgentAssist}>
                            {getMoreAssistance}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssistanceTab;

